import React, { useState, Fragment } from 'react';

import SurveySettings from '../SurveySettings';
import SurveyTarget from '../SurveyTarget';
import Questions from '../Questions';
import Dictionary from '../Dictionary';
import SurveySummary from '../SurveySummary';
import IEStepHeader from '../IEStepHeader';
import IELoading from '../IELoading';

const getSteps = () => [
  'Survey Settings',
  'Target',
  'Questions',
  'Dictionary',
  'Summary',
];

const getStepContent = (step, props) => {
  switch (step) {
    case 0:
      return <SurveySettings {...props} />;
    case 1:
      return <SurveyTarget {...props} />;
    case 2:
      return <Questions {...props} />;
    case 3:
      return <Dictionary {...props} />;
    case 4:
      return <SurveySummary {...props} />;
    default:
      return <IELoading />;
  }
};

const CreateSurvey = () => {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();

  const handleStep = step => {
    setActiveStep(step);
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  return (
    <Fragment>
      <IEStepHeader
        steps={steps}
        currentStep={activeStep}
        onStepChange={handleStep}
      />
      <div className="ie--steps--screen">
        <div className="ie--container">
          {getStepContent(activeStep, { handleBack, handleNext })}
        </div>
      </div>
    </Fragment>
  );
};

export default CreateSurvey;
